import { FunctionComponent } from 'react';
import { AuthorModel } from '../../../services/content/author/models/AuthorModel';
import { hasAuthors } from '../../../constants/GlobalHelpers';
import { Author } from './Author';

type Props = {
    authors: AuthorModel[];
    customAuthor: string;
};
export const AuthorList: FunctionComponent<Props> = ({ authors, customAuthor }) => {
    if (!hasAuthors(authors, customAuthor)) {
        return null;
    }

    return (
        <div className='d-flex flex-column flex-md-row justify-content-start'>
            {authors
                .filter((author) => author.active)
                .map((author) => (
                    <Author
                        author={author}
                        key={`author-listing-key-${author.name}`}
                        className='mb-2 mb-md-0 me-md-2'
                    />
                ))}
            {customAuthor ? <Author customAuthor={customAuthor} className='mb-2 mb-md-0 me-md-2' /> : null}
        </div>
    );
};
